module.exports = __webpack_public_path__ + "img/icon-no-invoice.ac5278e9.png";